import * as z from "zod";
import { creatorColumns } from "../rbac/roles";
import {
  grantPrincipalResolve,
  grantRoleResolve,
} from "../rbac/grantResources";
import {
  grantEntry,
  insertGrantsDeduped,
  validateGrants,
} from "../rbac/validation";
import { writeSkillMd } from "../skillFiles";
import { mutator } from "./mutator";
import { clientGeneratableIdSchema } from "../id";

const createSkillSchema = z.object({
  skillId: clientGeneratableIdSchema,
  name: z.string(),
  description: z.string(),
  instructions: z.string(),
  enabled: z.boolean(),
  grants: z.array(grantEntry).optional(),
});

export const createSkill = mutator({
  schema: createSkillSchema,
  resolve: {
    ...grantPrincipalResolve,
    ...grantRoleResolve,
  },
  permissions: [
    {
      permission: "tenant:skill_create",
      scopeId: ({ ctx }) => ctx.tenantId,
    },
  ],
  description: "Creates a new custom skill draft for the tenant.",
  interactionType: "create",
  fn: async ({
    tx,
    ctx,
    args: {
      skillId,
      name,
      description,
      instructions,
      enabled,
      grants,
      grantCustomRoles,
    },
  }) => {
    const content = {
      name: name.trim(),
      description: description.trim(),
      instructions,
    };
    if (grants) {
      validateGrants(grants, "skill", grantCustomRoles);
    }
    await tx.mutate.skills.insert({
      id: skillId,
      ...content,
      enabled,
      required: false,
      personalUse: "enabled",
      fresh: true,
      createdAt: Date.now(),
      ...creatorColumns(ctx),
      tenantId: ctx.tenantId,
    });
    await writeSkillMd(tx, skillId, ctx.tenantId, content);

    if (grants) {
      await insertGrantsDeduped(tx, grants, skillId, ctx.tenantId);
    }
  },
});
